import { Client } from "@/Common/Api/Client";
import { PortalLinkedItemType } from "@/Common/Models/Portal/Enums/PortalLinkedItemType";
import { SharedItemPriority } from "@/Common/Models/Portal/SharedItem/SharedItemPriority";
import { IPortalLinkedItemModel } from "@/Common/Models/Portal/UI/IPortalLinkedItemModel";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { ExportPatientChartPortalResponse } from "@/Patient/Components/MedicalItems/Immunization/ResponseModels/ExportPatientChartPortalResponse";
import { BaseSendToPortalPopupStrategy } from "@/Portal/Services/Strategies/BaseSendToPortalPopupStrategy";

class SendGrowthChartStrategy extends BaseSendToPortalPopupStrategy {
    public readonly disclaimer = "";
    public readonly itemCheckOperation: number = LocalPatientOperations.GrowthCharts.PortalGrowthChartMessageChecked;

    constructor() {
        super(
            PortalLinkedItemType.GrowthChart,
            LocalPatientOperations.GrowthCharts.PortalRevokedClicked,
            LocalPatientOperations.GrowthCharts.PortalStatusCancel
        );
    }

    public async onSendToPortalClick(subject: string, newMessage: string, includeDocument: boolean, _portalItemModel?: IPortalLinkedItemModel, priority?: SharedItemPriority, canPatientReplyWithMessage?: boolean): Promise<void> {
        const response = await Client.postAsync<ExportPatientChartPortalResponse>(
            ServerOperations.Server.Myle_Patient_ExportPortalCharts,
            patientStore.GrowthChartUiModels[patientStore.getCurrentPatientContactId()].get("exportPatientChartData")
        );

        if (response.isSuccess) {
            sessionStore.dispatch(
                LocalPatientOperations.GrowthCharts.PortalSendClicked,
                {
                    subject: subject,
                    messageText: newMessage,
                    includeDocument: includeDocument,
                    attachmentId: response.data.AttachmentId,
                    priority: priority,
                    canPatientReplyWithMessage: canPatientReplyWithMessage
                }
            );
        }
    }
}

export { SendGrowthChartStrategy };
